import { getDataCommon } from "./common";

export const getHomeData = () => getDataCommon("home.json");

export const getNewsData = () => getDataCommon("news.json");

export const getContactOfficeData = () => getDataCommon("organization.json");
